import { Box, Checkbox, Icon, InputLabel, styled, TextField, Typography } from "@mui/material"
import { uid } from "uid"
import Icons from "../../assets/js/Icons"

const Image = styled("img")(() => ({}))
function RadioLabel({ id, image, name, onChangeFun, option, value, imageType, label, radioIcon = true, type, onClick }) {
  id = id || uid(6)

  return (
    <>
      <InputLabel
        htmlFor={id}
        sx={{
          px: 3,
          py: 2,
          borderRadius: "8px",
          transition: "all 400ms ease",
          bgcolor: "primary.100",
          ".MuiTypography-root": { color: "primary.main" },
          ":has(input:checked)": {
            bgcolor: "primary.light",
            ".filled": { opacity: "1" },
            ".MuiIcon-root": { color: "white" },
            ".MuiTypography-root": { color: "white" },
            ".holo": {
              opacity: "0",
              transform: "scale(0.8)",
            },
          },
          ":not(:has(input:checked))": {
            ".holo": { opacity: "1" },
            ".filled": {
              opacity: "0",
              transform: "scale(0.8)",
            },
          },
        }}
      >
        {type === "checkbox" ?
          <Checkbox
            id={id}
            name={name || null}
            value={value || null}
            sx={{ display: "none" }}
            onChange={onChangeFun || onClick || null}
          /> :
          <TextField
            id={id}
            name={name || null}
            value={option?.value}
            sx={{ display: "none" }}
            onChange={onChangeFun || null}

            type={"radio"}
          />
        }
        <Box
          sx={{
            gap: 1.5,
            display: "flex",
            alignItems: "center",
          }}
        >
          {radioIcon &&
            <Icon
              sx={{
                color: "primary.main",
                position: "relative",
                "lightingColor, .filled": {
                  inset: "0",
                  position: "absolute",
                  transform: "scale(1.1)",
                  transition: "all 250ms ease",
                }
              }}
            >
              {type === "checkbox" ?
                <>
                  <span className="filled">
                    <Icons.Checkmark />
                  </span>
                  <span className="holo">
                    <Icons.PlusSolid />
                  </span>
                </> :
                <>
                  <span className="filled">
                    <Icons.RadioSolid />
                  </span>
                  <span className="holo">
                    <Icons.CircleStroke />
                  </span>
                </>
              }
            </Icon>
          }
          <Typography
            component="span"
            fontWeight="600"
            whiteSpace="normal"
          >{label}
          </Typography>
          {image &&
            <Image
              sx={{
                ml: "auto",
                display: "block",
                objectFit: "contain",
                height: imageType ? 40 : 60,
                filter: 'drop-shadow(0 0 10px #00000030)'
              }}
              alt="img"
              src={image}
            />
          }
        </Box>
      </InputLabel>
    </>
  )
}

export default RadioLabel